var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      { staticClass: "both-pd-box1" },
      [
        _c(
          "div",
          {
            staticStyle: {
              background: "#fff",
              padding: "10px 30px",
              "border-radius": "20px",
            },
          },
          [
            _c("h3", [_vm._v("搜索页面管理")]),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "demo-form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "200px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "顶部营销位", prop: "isShow" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.isShow,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isShow", $$v)
                              },
                              expression: "form.isShow",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("打开"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("关闭"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "顶部营销位主图", prop: "imgUrl" } },
                      [
                        _c("upload", {
                          attrs: { name: "imgUrl", "img-url": _vm.form.imgUrl },
                          on: {
                            pictureAddress: function ($event) {
                              return _vm.onPictureAddress($event)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticStyle: { color: "#aaaaaa" } }, [
                          _vm._v("建议尺寸690px*120px PNG图片"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "营销位跳转入口", prop: "Entrance" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "800px" },
                          attrs: {
                            placeholder: "请选择活动 or 粘贴链接到此处",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.Entrance,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "Entrance", $$v)
                            },
                            expression: "form.Entrance",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pointer",
                            staticStyle: { color: "#389bff" },
                            on: {
                              click: function ($event) {
                                return _vm.onOfficialEvent()
                              },
                            },
                          },
                          [_vm._v("\n              去选择\n            ")]
                        ),
                        _vm._v(" "),
                        _vm.form.ActivityName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "6px",
                                  background: "#eee",
                                  width: "fit-content",
                                  padding: "0 20px",
                                  "border-radius": "6px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.form.Display_name) +
                                    "---  " +
                                    _vm._s(_vm.form.ActivityName) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSubmit },
                          },
                          [_vm._v(" 保存 ")]
                        ),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.handleReset } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("ActivitySelectionPopup", {
          ref: "activitySelectionPopup",
          on: { SelectEvents: _vm.onSelectEvents },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }